module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-job-public-details",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Job Details\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Job Reference")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.job.number) + "\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "m-b-sm"
  }, [(_vm.jobHasEnoughDetails) ? [_vm._v("\n            " + _vm._s(_vm.job.commodity_and_location_with_quantity) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Approx Distance")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.distance) + "\n        ")]), _vm._v(" "), (_vm.jobHasCoordinator) ? _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Coordinator:")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.job.coordinator.profile.full_name) + " " + _vm._s(_vm.job.coordinator.mobile) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Notes")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.job.notes) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('distance-map', {
    ref: "map",
    attrs: {
      "location-from": _vm.job.location_from,
      "location-to": _vm.job.location_to
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 footer-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 footer-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7a267b0d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobBoardModal.vue
// module id = 1049
// module chunks = 0